import {AbstractControl} from "@angular/forms";
import {Component, Input, ViewChild} from "@angular/core";
import {AddressDataInfoDto} from "../../../models/student-ticket/list-view/AddressDataInfoDto";
import {AbstractFormModalComponent} from "../../../shared/modal/abstract-form-modal.component";
import {ModalShellComponent} from "../../../shared/modal/modal-shell/modal-shell.component";
import {AddressDetailsFormComponent} from "../../../shared/address-details-form/address-details-form.component";

@Component({
  selector: 'app-address-details-adjust-modal',
  templateUrl: './address-details-adjust-modal.component.html',
  styleUrls: ['./address-details-adjust-modal.component.scss'],
  imports: [
    ModalShellComponent,
    AddressDetailsFormComponent
  ],
  standalone: true
})
export class AddressDetailsAdjustModalComponent extends AbstractFormModalComponent {

  @Input() addressDetails: AddressDataInfoDto;

  protected validationErrorKey = 'ADDRESS_DATA.VALIDATION_ERROR';

  @ViewChild(AddressDetailsFormComponent) private addressForm: AddressDetailsFormComponent;

  protected get form(): AbstractControl {
    return this.addressForm?.form;
  }

  protected getCloseValue(): unknown {
    return this.addressForm.getFormValue();
  }
}
